export enum ProfileEnum {
    'Minister-PID',
    'Minister-ELEKTR',
    'Minister-MAX',
    'Minister-43',
    'SafeIT-HUM',
    'Smartvent',
    'SmartventV2',
    'Haba',
    'Cobra',
    'Solar',
    'HabaMultiBio2000',
    'HabaMultiBio3200',
    'Minister-PELET',
    'Minister-ZG',
    'Minister-JFC',
    'Retrofit-JFC',
    'Mouse-trap-gate',
    'Minister-Kolor-28',
    'Minister-Kolor-28-Corn',
    'Minister-Kolor-28-Smok',
    'Minister-Kolor-28-Dual-Fuel',
    'Wind-Turbine-Control',
    'Wind-Turbine-Control-28',
    'Wind-Turbine-Control-Gondola',
    'Windster',
    'Minister-WSTER',
    'LFP-ePomp',
    'Tweetop-pompa',
    'Tweetop-OP',
    'Tweetop-pompa-v2',
    'INVERTER_MASTER',
    'ANEMOMETER_MASTER',
    'HabaMultiBio3100v2'
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ProfileEnum {
    // eslint-disable-next-line no-inner-declarations
    export function names(): Array<string> {
        const keys = Object.keys(ProfileEnum);
        return keys.slice(keys.length / 2, keys.length - 1);
    }
}
